export const ThesisType = ["undergraduate", "masters"];
